import { Component, OnInit, OnDestroy } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadCrumbModel, StepIndicatorService, StepIndicatorModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { STEPINDICATORS } from 'config';
import { TransactionService } from './shared/providers/transaction.service';
import { ENV } from 'config';
declare var ENV_VAR: any;


@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss'],
  providers: [StepIndicatorService, TransactionService]
})



export class TransactionComponent implements OnInit, OnDestroy {
  public steps: Array<StepIndicatorModel>;
    private companyId: number;
    displayFlag: boolean;
    sessionName: string;
    constructor(private breadCrumbService: BreadCrumbService,
        private stepIndicator: StepIndicatorService,
        private utilities: UtilityService,
        private transactionReportService: TransactionService,
        private route: ActivatedRoute) {
        this.steps = STEPINDICATORS.transaction;
    }

    ngOnInit() {
        const breadcrumb = new BreadCrumbModel();
        breadcrumb.label = 'Account activity request';
        breadcrumb.routerLink = '/reports/transaction';
        this.breadCrumbService.setCurrentBreadCrumb(breadcrumb);
        this.sessionName = 'transaction';
        if (this.stepIndicator.getSteps(this.sessionName) === null) {
          this.stepIndicator.setSteps(this.steps, this.sessionName);
        }
        this.steps = this.stepIndicator.getSteps(this.sessionName);
        this.stepIndicator.getVisibility().subscribe(
          (status: boolean) => {
            this.displayFlag = status;
          }
        );
    }

    ngOnDestroy() {
        this.transactionReportService.removeReportModel();
        this.stepIndicator.removeStep('transaction');
    }

}
